export const FAQ_ITEMS = {
    WHAT_IS_COMPANY: 'what-is-company',
    HOW_TO_START: 'how-to-start',
    WHAT_IS_NFT: 'what-is-nft',
    PLATFORM_FEES: 'platform-fees',
    WHAT_IS_SC: 'what-is-sc',
    HOW_SC_WORK: 'how-sc-work',
    WHERE_VIEW_SC: 'where-view-sc',
    WHAT_USE_FOR_PAYMENT: 'what-use-for-payment',
    HOW_PURCHASE_AUCTION: 'how-purchase-auction',
    WHAT_IS_MINTING: 'what-is-minting',
    ARE_NFTS_REFUNDABLE: 'are-nfts-refundable',
    MORE_THAT_ONE_CATEGORY: 'more-that-one-category',
    WHERE_FIND_NFT: 'where-find-nft',
    ROYALTIES: 'royalties',
    CAP_OF_ROYALTIES: 'cap-of-royalties',
    WHAT_WALLET_IS_USED: 'what-wallet-is-used',
    OTHER_WALLET: 'other-wallet',
    WHERE_CAN_I_DOWNLOAD_WALLETS: 'where-can-i-download-wallets',
    HOW_TO_CONNECT_CRYPTOX: 'how-to-connect-cryptox',
    HOW_TO_CONNECT_METAMASK: 'how-to-connect-metamask',
    MINIMUM_CCD_TRANSACT: 'minimum-ccd-transact',
    CAN_VIEW_NFT_WALLET: 'can-view-nft-wallet',
    USAGE_LAUNCHPAD: 'usage-launchpad',
    UPLOAD_BULK: 'upload-bulk',
    HOW_TO_ADD_CRYPTOWALLET: 'how-to-add-cryptowallet',
    HOW_TO_INTEGRATE_CRYPTOWALLET_INTO_APP: 'how-to-integrate-cryptowallet-into-app',
};